import PropTypes from "prop-types";
import * as React from "react";
import { Product } from "../../../domain";
import { ProductImage, ProductText } from "../../Product";
import css from "./DragOverlayProduct.module.css";

const DragOverlayProduct = React.memo(function DragOverlayProduct({
  product,
  width,
}) {
  if (!product) return null;

  return (
    <div className={css.overlay} style={width ? { width } : undefined}>
      <ProductImage product={product} />
      <ProductText product={product} />
    </div>
  );
});

DragOverlayProduct.propTypes = {
  product: PropTypes.instanceOf(Product),
  width: PropTypes.number,
};

export default DragOverlayProduct;
